"use strict";
import CartModalController from 'emun.cart/cart-modal.controller'
import cartConfig from 'emun.cart/cart.config'

class OrderInfoPromptController extends CartModalController {
    constructor($session, $cart, $uibModalInstance, options, createAutoQuery) {
        'ngInject';
        super($session, $cart, $uibModalInstance, options);
        this.config = cartConfig;
        this.contacts = createAutoQuery({
            url: 'QueryRetailerContacts.json?active=true&retailerId=' + this.request.retailerId,
            orderBy: 'Name',
            autoLoad: true,
            pageSize: 10
        });
    }

    submit() {
        let $ctrl = this;
        return $ctrl.$cart.applyOrderInfo($ctrl.request).then(res => {
            $ctrl.prompt[$ctrl.request.id ? 'edited': 'created'].notify(res);
            $ctrl.$close(res);
        });
    }
}

function OrderInfoPromptFactory($q, modals) {
    'ngInject';
    class OrderInfoPrompt {
        constructor() {
            var me = this;
            //promises
            ['editing', 'creating', 'edited','created'].forEach(k => {
                me[k] = $q.defer();
                me[k].on = me[k].subscribe = me[k].sub = cb => me[k].promise.finally(null, cb);
            });
        }
        open(options) {
            let prompt = this;
            let modalInstance = prompt.modal = modals.open({
                size: 'md',
                templateUrl: 'order-info-prompt.html',
                controller: OrderInfoPromptController,
                bindToController: true,
                controllerAs: '$ctrl',
                resolve: {
                    options: () => Object.assign({prompt},options)
                }
            });

            return modalInstance.result;
        }
    }
    return OrderInfoPrompt;
}

function OrderInfoPromptDirectiveFactory(OrderInfoPrompt, $parse, $cart) {
    return {
        restrict: 'EA',
        scope: false,
        link: function (scope, element, attr) {
            var prompt = new OrderInfoPrompt();
            attr.onEdited && me.edited.subscribe(args => $parse(attr.onEdited)(scope, args));
            attr.onCreated && me.created.subscribe(args => $parse(attr.onCreated)(scope, args));
            attr.ngModel && $parse(attr.ngModel).assign(scope, prompt);

            var $targets = (attr.clickSelector ? element.find(attr.clickSelector) : element);
            console.debug('OrderInfoPromptDirectiveFactory.$targets', $targets);
            $targets.on('click', e => {
                console.log('OrderInfoPromptDirectiveFactory.click', e);
                var cart = attr.order ? scope.$eval(attr.order) :  $cart;
                console.log('cart.click', cart);
                var request = {
                    cartId: cart.id,
                    shipOn: cart.shipOn,
                    cancelOn: cart.cancelOn,
                    purchaseOrder: cart.purchaseOrder,
                    buyer: cart.buyer,
                    shippingMethodId: cart.shippingMethod.id,
                    retailerId: cart.purchaser.id,
                    //paymentTermId: cart.paymentTerms.id,
                    email: cart.purchaser.email,
                    note: cart.note
                };
                request.shipOn = moment(request.shipOn);
                request.shipOnString = moment(request.shipOn).format("MM/DD/YYYY");
                console.log('request', request);
                prompt.open({
                    title: attr.title,
                    request
                });
            });
        }
    }
}

angular.module('emun.cart')
    .factory('OrderInfoPrompt', OrderInfoPromptFactory)
    .directive('orderInfoPrompt', OrderInfoPromptDirectiveFactory);